import { brandedString } from 'src/helpers/brandedString';

/**
 * Global/module actions
 *
 * These are not bound to a resource instance `id` and can be fetched initially
 * at once.
 *
 * @todo: Ideally schema would expose them
 */
export const GLOBAL_ACTIONS = brandedString({
  APP_ACCESS: 'management-portal:access',
  HOME_ACCESS: 'management-portal:home.access',
  INVITATIONS_ACCESS: 'management-portal:internal-only',
  ORGS_ACCESS: 'management-portal:organizations.access',
  ORGS_ORGANIZATION_LIST: 'organizations:organization.list',
  TM_ACCESS: 'management-portal:tenant-management.access',
  TM_APPLICATION_LIST_CREATE: 'tenant-management:application-list.create',
  TM_APPLICATION_LIST_LIST: 'tenant-management:application-list.list',
  USERS_USER_LIST: 'users:user.list',
});

export type GlobalAction = (typeof GLOBAL_ACTIONS)[keyof typeof GLOBAL_ACTIONS];
